export const WAIT_FOR_SURVEY_CHANGE_TIME = 5000;

export const SERVER_UPDATE_TIME = 4000;

export const NEW_SURVEY_CREATE_UPDATE_SERVER_DELTA = 1000;
